// extracted by mini-css-extract-plugin
export default {"btnContainer":"Teams_btnContainer__YJFd6"};